import { Component, Input } from '@angular/core';
import { ChatbotActions } from '../../state/chatbot.actions';
import { Store } from '@ngxs/store';
import { ChatbotState } from '../../state/chatbot.state';
import { TenantConfigService } from '../../../../../../../tenant-config/tenant-config.service';

@Component({
  selector: 'hf-chatbot-header',
  templateUrl: './chatbot-header.component.html',
  styleUrls: ['./chatbot-header.component.scss']
})
export class ChatbotHeaderComponent {
  @Input() chatbotName?: string;
  @Input() isFullScreen: boolean;

  constructor(
    private readonly store: Store,
    public readonly tenantConfigService: TenantConfigService
  ) {}

  // Method that expands the chatbot to full screen.
  // If already full screen, it returns to the default chat height + width.
  public onFullScreenClick() {
    this.handleChatView(false, true);
  }

  // Method that collapses the chatbot to minimised state.
  // If full screen, it returns to the default chat height + width.
  public onBackButtonClick() {
    this.handleChatView(true);
  }

  // Method that initiates the new chat flow.
  public onNewChatClick() {
    const existingChat = this.store.selectSnapshot(ChatbotState.chatbotMessageHistory);
    const newChatStateUI = this.store.selectSnapshot(ChatbotState.isNewChatState);

    if (existingChat.length > 0) {
      return this.store.dispatch(new ChatbotActions.WarningStateUI(true));
    }
    if (newChatStateUI) {
      return;
    }
    this.store.dispatch(new ChatbotActions.NewChatUI(true));
    this.store.dispatch(new ChatbotActions.StartNewWSConversation());
  }

  // Handler for chat view state
  private handleChatView(minimiseOnNotFull: boolean, toggleFullScreen?: boolean) {
    const isFullScreen = this.store.selectSnapshot(ChatbotState.isFullScreen);

    if (isFullScreen) {
      // Always exit full screen first
      return this.store.dispatch(new ChatbotActions.ToggleFullScreen(false));
    }

    if (minimiseOnNotFull) {
      // Collapse to minimised state
      return this.store.dispatch(new ChatbotActions.ToggleMinimise(true));
    }

    if (toggleFullScreen) {
      // Expand to fullscreen
      return this.store.dispatch(new ChatbotActions.ToggleFullScreen(true));
    }
  }
}
